import React from 'react'
import styled from "styled-components";
import { useHistory } from 'react-router-dom';
import routes from 'routes';

export default function Setup() {
	const history = useHistory()
  return (
    <div>
        <h4>Setup</h4>

		<div className='d-flex gap-3'>
		     {/* <button
                color="primary"
                variant="contained"
                type="submit"
                className="btn btn-outline-success px-5 py-4 my-4 rounded mx-2"
                onClick={() => history.push(routes.myunderwriters)}
              >
				Underwriter
              </button> */}

			  
			  	<button
                color="primary"
                variant="contained"
                type="submit"
                className="btn btn-outline-success px-5 py-4 my-4 rounded mx-2"
                onClick={() => history.push(routes.addrate)}
              >
				Rates
              </button>

			  	<button
                color="primary"
                variant="contained"
                type="submit"
                className="btn btn-outline-success px-5 py-4 my-4 rounded mx-2"
				onClick={() => history.push(routes.adddmvic)}
              >
				DMVIC
              </button>

			   <button
                color="primary"
                variant="contained"
                type="submit"
                className="btn btn-outline-success px-5 py-4 my-4 rounded mx-2"
                	onClick={() => history.push(routes.productlist)}
              >
				Products
              </button>



			  	     <button
                color="primary"
                variant="contained"
                type="submit"
                className="btn btn-outline-success px-5 py-4 my-4 rounded mx-2"
				onClick={() => history.push(routes.addbenefit)}
              >
				Benefit
              </button>
		</div>


			  
    </div>
  )
}
